<template>
    <div id="duplicate-modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">DUPLICATE FORM SETTINGS</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <form data-vv-scope="duplicate-form">

                                <div class="form-group" :class="{ 'has-error': errors.has('duplicate-form.Name') }">
                                    <label>Name</label>
                                    <input type="text" class="form-control" v-model="duplicateName" name="Name"
                                           v-validate="'required'">
                                    <span v-show="errors.has('duplicate-form.Name')" class="help-block">{{ errors.first('duplicate-form.Name') }}</span>
                                </div>

                                <div class="form-group"
                                     :class="{ 'has-error': errors.has('duplicate-form.Description') }">
                                    <label>Description</label>
                                    <textarea type="text" class="form-control" v-model="duplicateDesc"
                                              name="Description" v-validate="'required'"></textarea>
                                    <span v-show="errors.has('duplicate-form.Description')" class="help-block">{{ errors.first('duplicate-form.Description') }}</span>
                                </div>

                                <div class="form-group" :class="{ 'has-error': errors.has('duplicate-form.Location') }">
                                    <label>Select Location</label>
                                    <select class="form-control" name="Location" v-model="duplicateType"
                                            v-validate="'required'">
                                        <option value="form">Form</option>
                                        <option value="template">Template</option>
                                    </select>
                                    <span v-show="errors.has('duplicate-form.Location')" class="help-block">{{ errors.first('duplicate-form.Location') }}</span>
                                </div>

                                <div class="form-group" v-if="duplicateType == 'form'"
                                     :class="{ 'has-error': errors.has('duplicate-form.Related') }">
                                    <label>Related to</label>
                                    <select class="form-control" v-model="duplicateModule" name="Related"
                                            v-validate="'required'">
                                        <option v-for="module in filteredModules" :value="module.key">{{ module.name }}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('duplicate-form.Related')" class="help-block">{{ errors.first('duplicate-form.Related') }}</span>
                                </div>

                                <div class="form-group"
                                     v-if="duplicateModule == 'organization_organization' || duplicateModule == 'organization_general'"
                                     :class="{ 'has-error': errors.has('duplicate-form.User Access') }">
                                    <label>User access</label>
                                    <select class="form-control" v-model="duplicateAccessLevel" name="User Access"
                                            v-validate="'required'">
                                        <option v-for="accessLevel in accessLevels" :value="accessLevel.key">{{
                                            accessLevel.name }}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('duplicate-form.User Access')" class="help-block">{{ errors.first('duplicate-form.User Access') }}</span>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn green mt-ladda-btn ladda-button duplicated-btn" @click.prevent="runDuplicate"
                            data-style="expand-left">
                        <span class="ladda-label">Add Form</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";

    export default {

        props: ['duplicateFormId'],
        data() {
            return {
                accessLevels: [
                    {
                        'name': 'Case Manager',
                        'key': 'CASE_MANAGER',
                    },
                    {
                        'name': 'Supervisor',
                        'key': 'SUPERVISOR',
                    },
                    {
                        'name': 'Program Administrator',
                        'key': 'PROGRAM_ADMINISTRATOR'
                    }
                ],
                duplicateName: '',
                duplicateDesc: '',
                duplicateModule: '',
                duplicateType: 'form',
                duplicateAccessLevel: null,
                formType: '',
                show: false,
            }
        },

        computed: {
            ...mapGetters({
                'modules': 'getModules',
                'duplicatingFailed': 'getDuplicatingFailed',
                'newForm': 'getLastCreatedForm'
            }),
            filteredModules() {
                return this.modules.filter(module => !['profile','contact','assignment'].includes(module.role));
            }
        },

        mounted() {
            this.fetchModules();
            $('#duplicate-modal').modal('show');
            $('#duplicate-modal').on('hidden.bs.modal', () => {
                this.$emit('hide');
            });
        },

        methods: {
            ...mapActions([
                'fetchModules',
                'duplicateForm'
            ]),

            runDuplicate() {
                this.$validator.validateAll('duplicate-form').then((result) => {
                    if (result) {

                        this.button = Ladda.create(document.querySelector('.duplicated-btn'));
                        this.button.start();

                        let data = {
                            id: this.duplicateFormId,
                            name: this.duplicateName,
                            description: this.duplicateDesc,
                            module: this.duplicateModule,
                            type: this.duplicateType,
                        };

                        this.duplicateForm(data).then((successful) => {
                            this.button.stop();
                            $('#duplicate-modal').modal('hide');

                            if (successful) {
                                this.$emit('duplicate-success', this.newForm.id);
                            }
                        });
                    }
                });
            },
        },

        inject: {
            $validator: '$validator'
        }
    }

</script>

<style scoped>
    #duplicate-modal {
        right: 20px;
        left: initial;
        top: 60px;
    }
</style>



// WEBPACK FOOTER //
// DuplicateFormModal.vue?b94f395c